import { handleErrorWithSentry, replayIntegration } from '@sentry/sveltekit'
import * as Sentry from '@sentry/sveltekit'
import { SENTRY_DSN } from '#lib/sentry.js'
import { setExceptionReporter } from '$utils/reportException'

Sentry.init({
	dsn: SENTRY_DSN,

	// 10% tracing in all environments; every sampled request is billed
	tracesSampleRate: 0.1,

	// Enable logs to be sent to Sentry
	enableLogs: true,

	// dev: full replay while testing; prod: 10% per official tier guidance (docs/SENTRY.md)
	replaysSessionSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
	// error sessions always record in full
	replaysOnErrorSampleRate: 1.0,

	// If you don't want to use Session Replay, just remove the line below:
	integrations: [replayIntegration()],

	dataCollection: {
		// To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
		// https://docs.sentry.io/platforms/javascript/guides/sveltekit/configuration/options/#dataCollection
		// userInfo: false,
		// httpBodies: [],
	}
})

// route doHandle captures to Sentry — kit-only, the bridge bundle stays sentry-free (docs/SENTRY.md P4)
setExceptionReporter(Sentry.captureException)

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry()
